import {
  OnboardingAction,
  OnboardingActionParametersForm,
} from "@vviinn/user-managment-client-ts";

import { FormStep } from "../general";

export const mapUserBodyToOnboardingAction = (
  formSteps: FormStep[],
): OnboardingAction => {
  const formData = formSteps.reduce(
    (object, value) => ({ ...object, [value.name]: value.value }),
    {},
  );

  let data: OnboardingAction = {
    method: "PUT",
    formType: "onboarding",
    requestType: "PUT",
    parameters: {
      form: formData as OnboardingActionParametersForm,
    },
  };

  return data;
};
